import { SetupChecklist } from './checklist';

/**
 * The whole guided-setup checklist as its own screen.
 */
export const SetupScreen = () => (
  <div className="mx-auto max-w-3xl">
    <SetupChecklist />
  </div>
);
